import React from 'react'
import { FormButton, FormButtonContent } from '@myxplor/forms'
import { ContentToggleIcon } from '@myxplor/icons'
import withToggle from '../container'
import './show-hide.css'

const ShowHideView = ({ open, toggle, label, children }) => (
  <div className="showHide--wrapper">
    <FormButton center className="showHide--toggle" onClick={toggle}>
      <ContentToggleIcon left open={open} />
      <FormButtonContent>
        {`${open ? 'Hide' : 'View'} ${label || 'more details'}`}
      </FormButtonContent>
    </FormButton>

    {open ? <div className="showHide--content">{children}</div> : null}
  </div>
)

export default withToggle(ShowHideView)



// WEBPACK FOOTER //
// ./src/ui/show-hide/views/index.jsx